<template>
    <v-app id="app" class="bg-image full-height" v-bind:style="{backgroundImage: 'url(' + image + ')' }">

        <v-layout wrap style="overflow: hidden;">

            <div class="full-height container-of-fullheight-element" style="position: absolute;display: flex;flex-flow: column;align-items: stretch;">

                    <ToolBar transparent login v-on:login="login=true" style="flex: 0 1 64px;"/>

                    <div class="fullheight-element" style="flex: 1 1 auto; overflow: auto;">
                        <v-content class="full-height">
                            <router-view></router-view>
                        </v-content>
                    </div>

                    <Footer ref="footer" transparent style="flex: 0 1 60px;"/>

            </div>

            <v-navigation-drawer
                    v-model="login"
                    fixed app right
                    temporary
                    width="500">
                <LoginDrawer ref="logindrawer" v-on:close="closeLogin" :onlyLogin="onlyLogin"/>
            </v-navigation-drawer>

        </v-layout>
        <vue-particles color="#E5CB5B"
                       :particleOpacity="0.7"
                       :particlesNumber="100"
                       shapeType="circle"
                       :particleSize="5"
                       linesColor="#E5CB5B"
                       :linesWidth="2"
                       :lineLinked="true"
                       :lineOpacity="0.4"
                       :linesDistance="150"
                       :moveSpeed="3"
                       :hoverEffect="true"
                       hoverMode="grab"
                       :clickEffect="true"
                       clickMode="push"
        >

        </vue-particles>

    </v-app>
</template>

<script>
    import Repository from "../repositories/Repository";

    import LoginDrawer from "@/components/LoginDrawer";
    import Footer from "./components/Footer";
    import ToolBar from "./components/ToolBar";

    import { VApp, VLayout, VContent, VNavigationDrawer } from 'vuetify/lib'

    export default {
        name: 'DefaultLayout',
        components: {
            Footer,
            ToolBar,
            LoginDrawer,
            VApp,
            VContent,
            VLayout,
            VNavigationDrawer
        },
        data () {
            return {
                image: {},
                login: false,
                isModalVisible: false,
                informationModal: 'ggwp',
                modalmsg: '',
                onlyLogin: false,
            }
        },
        created() {
            this.getRandomImageOfDay();
            this.$root.$on('show-login', (options) => {
                this.login=true;
                this.$refs.logindrawer.goLogin(options);
            });
            this.$root.$on('show-register', (options) => {
                this.login=true;
                this.$refs.logindrawer.goRegister(options);
            });
            this.$root.$on('show-login-drawer', (event) => {
                this.login=true;
                this.$refs.logindrawer.setEmail(event.email);
            });
            if (this.$route.name === 'login') {
                this.login = true;
                this.onlyLogin = true;
            }

            let options = null;
            if (this.$route.query.email) {
                options = {email:this.$route.query.email};
            }
            if (this.$route.query.login == 1) {
                this.$root.$emit('show-login',options);
            }
            if (this.$route.query.register == 1) {
                this.$root.$emit('show-register',options);
            }
        },
        methods: {
            getRandomImageOfDay() {
                Repository.new().get("/day-image")
                    .then((response)=>{
                        if (response.url) {
                            this.image = response.url;
                        } else if (response.data && response.data.url) {
                            this.image = response.data.url;
                        } else {
                            this.setFixedImage();
                        }

                        if (response.data && response.data.text) {
                            this.$refs.footer.setCopyright(response.data.text);
                        }
                    })
                    .catch(()=>{
                        this.setFixedImage();
                    })
            },
            goHome() {
                this.$router.push({name: 'root', replace: true})
            },
            setFixedImage() {
                this.image = "https://images.freeimages.com/images/large-previews/da8/cadbury-the-rabbit-1404046.jpg";
            },
            closeLogin(){
                this.login=false;
            },
        },
    };
</script>

<style scoped>
    .bg-image {
        background-size: cover!important;
        background-position: center!important;
    }
    #particles-js {
        height: 100%;
        overflow: hidden;
    }
</style>
